__turbopack_context__.v({
  "gray_rounded_box": "StartSurveyContainer-module-scss-module__kBOeUG__gray_rounded_box",
  "list_icon": "StartSurveyContainer-module-scss-module__kBOeUG__list_icon",
  "list_item": "StartSurveyContainer-module-scss-module__kBOeUG__list_item",
  "list_overtext": "StartSurveyContainer-module-scss-module__kBOeUG__list_overtext",
  "list_textbox": "StartSurveyContainer-module-scss-module__kBOeUG__list_textbox",
  "list_title": "StartSurveyContainer-module-scss-module__kBOeUG__list_title",
});
